const STOREFRONT_ENDPOINT = "/api/2025-10/graphql.json";
const STOREFRONT_TOKEN = "3e4eda6c69b97cbd516a85efc08d50e1";
const TARGET_BATCH = 300;
const MAX_HANDLES_PER_QUERY = 100;
const colorsCountorigFetch = window.fetch;
const publishedCache = Object.create(null);

async function fetchPublishedChunk(handles) {
  if (!handles.length) return;
  const fields = handles.map((h, i) => `h${i}: product(handle: "${h}") { handle publishedAt }`).join("\n");
  const query = `query { ${fields} }`;
  const res = await colorsCountorigFetch(STOREFRONT_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query })
  });
  if (!res.ok) {
    handles.forEach(h => { if (!(h in publishedCache)) publishedCache[h] = false; });
    return;
  }
  const data = await res.json();
  if (!data || !data.data) return;
  handles.forEach((h, i) => {
    const node = data.data[`h${i}`];
    publishedCache[h] = Boolean(node && node.publishedAt);
  });
}

async function ensurePublishedStatuses(handles) {
  const toFetch = handles.filter(h => !(h in publishedCache));
  if (!toFetch.length) return;
  const limited = toFetch.slice(0, TARGET_BATCH);
  for (let i = 0; i < limited.length; i += MAX_HANDLES_PER_QUERY) {
    const chunk = limited.slice(i, i + MAX_HANDLES_PER_QUERY);
    await fetchPublishedChunk(chunk);
  }
}

async function updateVariantPublishedCounts() {
  const els = document.querySelectorAll(".variant-published-count");
  if (!els.length) return;
  const allHandles = new Set();

  els.forEach(el => {
    const raw = (el.dataset.rawHandles || "").trim();
    if (!raw) return;
    const handles = raw.split(",").map(h => h.trim()).filter(Boolean);
    const parent = el.closest(".product__meta__color-variants");
    if (handles.length > 1 && handles[0].startsWith("shearling-cap-")) {
      el.textContent = String(handles.length);
      if (parent) {
        parent.style.display = "block";
        const span = parent.querySelector("span");
        if (span) span.style.opacity = 1;
      }
      return;
    }

    
    handles.forEach(h => allHandles.add(h));
  });

  await ensurePublishedStatuses(Array.from(allHandles));

  els.forEach(el => {
    const parent = el.closest(".product__meta__color-variants");
    const raw = (el.dataset.rawHandles || "").trim();
    if (!raw) return;
    const handles = raw.split(",").map(h => h.trim()).filter(Boolean).filter((h, i, a) => a.indexOf(h) === i);
    if (handles.length > 1 && handles[0].startsWith("shearling-cap-")) return;
    const publishedHandles = handles.filter(h => publishedCache[h]);
    if (publishedHandles.length <= 1) {
      el.textContent = "0";
      if (parent) parent.style.display = "none";
    } else {
      el.textContent = String(publishedHandles.length);
      if (parent) {
        parent.style.display = "block";
        const span = parent.querySelector("span");
        if (span) span.style.opacity = 1;
      }
    }
  });
}

window.fetch = function(input, init) {
  const p = colorsCountorigFetch.apply(this, arguments);
  const reqUrl = typeof input === "string" ? input : (input && input.url) || "";
  if (reqUrl && reqUrl.includes("/collections/")) {
    p.then(res => {
      const resUrl = (res && res.url) || "";
      if (resUrl.includes("/collections/")) {
        setTimeout(() => {
          updateVariantPublishedCounts().catch(() => {});
        }, 300);
      }
    }).catch(() => {});
  }
  return p;
};